import * as tslib_1 from "tslib";
import React from 'react';
import _ from 'lodash';
import { useLocalize } from '../../../hooks';
import { Text } from '../';
import { TextboxInput } from '../../fields';
export var DEFAULT_WIDTH = 1200;
export var DEFAULT_SMALL_COL = 2;
export var DEFAULT_MEDIUM_COL = 4;
export var DEFAULT_LARGE_COL = 6;
export var TextboxField = function TextboxField(_a) {
  var field = _a.field,
      form = _a.form,
      id = _a.id,
      label = _a.label,
      labelPrefix = _a.labelPrefix,
      isPercentage = _a.isPercentage,
      suppressError = _a.suppressError,
      rest = tslib_1.__rest(_a, ["field", "form", "id", "label", "labelPrefix", "isPercentage", "suppressError"]);

  var defaultLabelId = rest.defaultLabelId,
      errorAfterSubmit = rest.errorAfterSubmit;
  var values = form.values,
      errors = form.errors,
      touched = form.touched,
      submitCount = form.submitCount;

  var value = _.get(values, id);

  var error = _.get(touched, id) ? _.get(errors, id) : undefined;

  var _useLocalize = useLocalize(),
      getFieldTranslationId = _useLocalize.getFieldTranslationId; // showError will only show errors when field is touched or after submit if errorAfterSubmit is true
  // But suppress error display if suppressError prop is true


  var showError = suppressError ? false : errorAfterSubmit ? !!submitCount : !!_.get(touched, id);

  var formatValue = function formatValue(value) {
    if (field.value < 1) {
      if (field.name.toLowerCase() === 'width') return DEFAULT_WIDTH.toString();
      if (field.name.toLowerCase() === 'gridColumnsLarge') return DEFAULT_LARGE_COL.toString();
      if (field.name.toLowerCase() === 'gridColumnsMedium') return DEFAULT_MEDIUM_COL.toString();
      if (field.name.toLowerCase() === 'gridColumnsSmall') return DEFAULT_SMALL_COL.toString(); // This will handle cases where value could be 0 and avoid default values from overwriting it.

      return value;
    } else {
      return value;
    }
  };

  return React.createElement(React.Fragment, null, React.createElement(TextboxInput, Object.assign({
    name: id,
    label: label || React.createElement(Text, {
      id: getFieldTranslationId({
        id: id,
        defaultLabelId: defaultLabelId
      }),
      type: "field",
      data: labelPrefix && {
        prefix: labelPrefix
      }
    }),
    value: formatValue(value),
    error: error,
    onblur: field.onBlur,
    onchange: field.onChange,
    autoComplete: rest.autoComplete || id
  }, rest)), error && showError && React.createElement("span", {
    className: "error"
  }, React.createElement(Text, {
    id: id,
    textKey: "".concat(error),
    type: 'error',
    data: rest.data
  })));
};